import { useLocation } from 'react-router-dom';

const ITR_ROUTE_PATTERNS = ['/itr', '/tax-return', '/tax/individual'] as const;

const ITR_TAG = 'itr';

/**
 * Checks if the given pathname is an ITR (Income Tax Return) page
 * Used to add 'itr' tag to tickets created from tax-related pages
 */
const isITRPage = (pathname: string): boolean => {
    const normalizedPath = pathname.toLowerCase();
    return ITR_ROUTE_PATTERNS.some((pattern) => normalizedPath.includes(pattern));
};

/**
 * Hook to manage ITR (Income Tax Return) configuration and routing
 * Determines if the current page is an ITR page and configures tags accordingly
 */
export default function useITRConfig() {
    const location = useLocation();

    const isOnITRPage = isITRPage(location.pathname);

    // Get the ITR tag if on an ITR page
    const itrTag = isOnITRPage ? [ITR_TAG] : [];

    return {
        isOnITRPage,
        itrTag,
    };
}
